import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import {createUseStyles} from "react-jss";

const spinners = {
  ring: require(`svg-inline-loader!~/assets/spinners/ring-spinner.svg`),
  heart: require(`svg-inline-loader!~/assets/spinners/heart-spinner.svg`),
};

const UISpinner = React.forwardRef(({variant, small, className, ...props}, ref) => {
  const classes = useStyles();
  if (!variant) {
    const now = (new Date());
    variant = (now.getDate() === 14 && now.getMonth() === 2) ? 'heart' : 'ring';
  }

  variant = (variant in spinners) ? variant : 'ring';

  return (
    <div
      ref={ref}
      className={cn(classes.root, classes[variant], {
        [classes.small]: small,
      }, className)}
      dangerouslySetInnerHTML={{__html: spinners[variant]}}
      {...props}
    />
  )
});

UISpinner.propTypes = {
  small: PropTypes.bool,
  variant: PropTypes.oneOf(['ring', 'heart']),
};

export default UISpinner;

const useStyles = createUseStyles({
  root: {
    display: 'inline-block',
    width: 32,
    height: 32,
  },

  small: {
    width: 24,
    height: 24,
  },

  ring: {color: '#ccc'},

  heart: {color: '#EA7E7C'}
});
